import React from "react";
import { TextBlockItem } from "../questionnaire-designer/components/text-blocks/component/item";
import {
  FieldInList,
  FieldsWithTextBlocksItem,
  FieldsWithTextBlocksItemType,
} from "./fields-with-text-blocks.types";

export type FieldsWithTextBlocksProps<
  F extends FieldInList,
  T extends TextBlockItem
> = {
  texts: T[];
  fields: F[];
};
export const useFieldsWithTextBlock = <
  F extends FieldInList,
  T extends TextBlockItem
>(
  props: FieldsWithTextBlocksProps<F, T>
) => {
  const getCombinedItems = React.useCallback(() => {
    return [
      ...props.fields.map((field) => ({
        ...field,
        itemType: FieldsWithTextBlocksItemType.field,
      })),
      ...props.texts.map((block) => ({
        ...block,
        itemType: FieldsWithTextBlocksItemType.textBlock,
      })),
    ]
      .map((item) => ({
        ...item,
        order:
          (item as FieldsWithTextBlocksItem<T>).order ??
          (item as FieldInList).original.order,
      }))
      .sort((a, b) => {
        return a.order - b.order;
      });
  }, [props.fields, props.texts]);

  return {
    getCombinedItems,
  };
};
